import React from "react";

import Container from "react-bootstrap/Container";
import { Navbar } from "react-bootstrap";

import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

import Logo from "../../common/images/logo.png";
import { PALETTE } from "../../common/ThemeConstants";

export default function SettingsHeader({ text = undefined, onClick }) {
  const navigate = useNavigate();
  return (
    <NavbarResponsive>
      <Container className="mb-1">
        <div style={{ width: 100 }}>
          <IoChevronBackOutline
            onClick={() => {
              navigate(-1);
            }}
            size={24}
            style={{ cursor: "pointer" }}
            color={PALETTE.TRUEGRAY}
          />
        </div>
        <div>
          <Navbar.Brand>
            <img
              className="d-block"
              width={80}
              src={Logo}
              alt="Federico Bartoli PT"
            />
          </Navbar.Brand>
        </div>
        <div className="text-end" style={{ width: 100 }}>
          {text && (
            <span
              style={{
                color: PALETTE.GRAY,
                paddingRight: 2,
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={onClick}
            >
              {text}
            </span>
          )}
        </div>
      </Container>
    </NavbarResponsive>
  );
}
